type PriceData = {
  line_1?: string;
  line_1_price?: number;
  line_2?: string;
  line_2_price?: number;
  active_line?: number;
  line_2_highlight?: boolean;
  rule?: string;
};

const priceInCurrency = (price: any) => {
  const config = useRuntimeConfig();

  // Parse the price as a float to support decimal values
  const parsedPrice = parseFloat(price);
  if (isNaN(parsedPrice)) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.log("Invalid price value", price);
    }
    return "";
  }

  const { getMaximumFractionDigits } = useHelpers();

  if (["HUF", "RON", "EUR"].includes(config.public.currency)) {
    return parsedPrice.toLocaleString(config.public.locale, {
      style: "currency",
      currency: config.public.currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: getMaximumFractionDigits(),
    });
  } else {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.log("Invalid currency", config.public.currency);
    }
    return "";
  }
};

const fromPriceInCurrencyWrap = (price: string, withPricelist1Text = false) => {
  const config = useRuntimeConfig();
  if (config.public.currency === "HUF") {
    if (withPricelist1Text) {
      return 'Tagsággal:  <span class="font-bold">' + price + "-tól</span>";
    } else {
      return price + "-tól";
    }
  }
  if (config.public.currency === "RON") {
    if (withPricelist1Text) {
      return 'de la <span class="font-bold">' + price + "</span> cu fidelizare";
    } else {
      return 'de la <span class="font-bold">' + price + "</span>";
    }
  }
  if (config.public.currency === "EUR") {
    // fixme: now only SK
    if (withPricelist1Text) {
      return 'od <span class="font-bold">' + price + "</span> s členstvom";
    } else {
      return 'od <span class="font-bold">' + price + "</span>";
    }
  }
  return "";
};

const priceInCurrencyWrap = (price: string) => {
  const config = useRuntimeConfig();
  if (config.public.currency === "HUF") {
    return 'Tagsággal:  <span class="font-bold">' + price + "</span>";
  }
  if (config.public.currency === "RON") {
    return '<span class="font-bold">' + price + "</span> cu fidelizare";
  }
  if (config.public.currency === "EUR") {
    // fixme: now only SK
    return '<span class="font-bold">' + price + "</span> s členstvom";
  }
  return "";
};

/*
New price formatting logic introduced in MNTX-158 in 2025 october.
We follow simpler logic.
Instead of one HTML block we need to return an object with separate keys and HTML values.
*/
export function usePriceFormatter2(price: any, method = "") {
  /*
  console.log(typeof price);
  console.log(method);
  console.log(price);
  */

  const { status, data } = useAuth();
  let useBasePrices = true;
  if (status.value === "authenticated") {
    if (
      Array.isArray(data?.value?.usergroups) &&
      data?.value?.usergroups?.includes(1)
    ) {
      useBasePrices = false;
    }
  }

  const returnData: PriceData = {
    line_1: "",
    line_1_price: 0,
    line_2: "",
    line_2_price: 0,
    line_2_highlight: false,
    active_line: 1,
    rule: "",
  };

  if (method === "masterProduct") {
    // full product meilisearch object, we need to take accoint the usergroup
    // console.log(price);

    if (!useBasePrices) {
      // 1.a, a felhasználó bejelentkezett és TV

      // 1.a.i
      if (
        price.calculated_base_prices.original_price_min ===
        price.calculated_base_prices.price_min
      ) {
        // 1.a.i.1. Igen (tehát nem akciós)

        // 1.a.i.1.a
        if (
          price.calculated_base_prices.price_min ===
          price.calculated_base_prices.price_max
        ) {
          // 1.a.i.1.a.i. Igen (tehát minden variánsnak egy ára van) - 7. kártya
          returnData.line_1 =
            '<span class="originalPrice whitespace-nowrap">' +
            priceInCurrency(price.calculated_base_prices.price_min) +
            "</span>";
          returnData.line_1_price = price.calculated_base_prices.price_min;
          returnData.line_2 =
            "<span>" +
            priceInCurrencyWrap(
              priceInCurrency(price.calculated_pricelist_1_prices.price_min),
            ) +
            "</span>";
          returnData.line_2_price = price.calculated_pricelist_1_prices.price_min;
          returnData.line_2_highlight = true;
          returnData.rule = "1.a.i.1.a.i.";
          returnData.active_line = 2;
        } else {
          // 1.a.i.1.a.ii. Nem (tehát több ár van) - 8. kártya
          returnData.line_1 =
            '<span class="originalPrice whitespace-nowrap">' +
            fromPriceInCurrencyWrap(
              priceInCurrency(price.calculated_base_prices.price_min),
            ) +
            "</span>";
          returnData.line_1_price = price.calculated_base_prices.price_min;
          returnData.line_2 =
            "<span>" +
            fromPriceInCurrencyWrap(
              priceInCurrency(price.calculated_pricelist_1_prices.price_min),
              true,
            ) +
            "</span>";
          returnData.line_2_price = price.calculated_pricelist_1_prices.price_min;
          returnData.line_2_highlight = true;
          returnData.rule = "1.a.i.1.a.ii.";
          returnData.active_line = 2;
        }
      } else {
        // 1.a.i.2. Nem (tehát akciós)

        // 1.a.i.2.a
        // eslint-disable-next-line no-lonely-if
        if (
          price.calculated_base_prices.original_price_min ===
          price.calculated_base_prices.original_price_max
        ) {
          // 1.a.i.2.a.i. Igen (tehát egyféle eredeti ár van)

          // 1.a.i.2.a.i.1.
          if (
            price.calculated_base_prices.price_min ===
            price.calculated_base_prices.price_max
          ) {
            // 1.a.i.2.a.i.1.a. Igen (tehát minden variánsnak egy akciós ára van) - 9. kártya
            returnData.line_1 =
              '<span class="originalPrice whitespace-nowrap">' +
              priceInCurrency(price.calculated_base_prices.original_price_min) +
              "</span>";
            returnData.line_1_price = price.calculated_base_prices.original_price_min;
            returnData.line_2 =
              '<span class="font-bold inActionPrice">' +
              priceInCurrency(price.calculated_base_prices.price_min) +
              "</span>";
            returnData.line_2_price = price.calculated_base_prices.price_min;
            returnData.rule = "1.a.i.2.a.i.1.a.";
            returnData.active_line = 2;
          } else {
            // 1.a.i.2.a.i.1.b. Nem (tehát több akciós ár van) - 10. kártya
            returnData.line_1 =
              '<span class="originalPrice whitespace-nowrap">' +
              fromPriceInCurrencyWrap(
                priceInCurrency(
                  price.calculated_base_prices.original_price_min,
                ),
              ) +
              "</span>";
            returnData.line_1_price = price.calculated_base_prices.original_price_min;
            returnData.line_2 =
              '<span class="font-bold inActionPrice">' +
              fromPriceInCurrencyWrap(
                priceInCurrency(price.calculated_base_prices.price_min),
              ) +
              "</span>";
            returnData.line_2_price = price.calculated_base_prices.price_min;
            returnData.rule = "1.a.i.2.a.i.1.b.";
            returnData.active_line = 2;
          }
        } else {
          // 1.a.i.2.a.ii. Nem (tehát több eredeti ár van)

          // 1.a.i.2.a.ii.1.
          // eslint-disable-next-line no-lonely-if
          if (
            price.calculated_base_prices.price_min ===
            price.calculated_base_prices.price_max
          ) {
            // 1.a.i.2.a.ii.1.a. Igen (tehát minden variánsnak egy akciós ára van) - 11. kártya
            returnData.line_1 =
              '<span class="originalPrice whitespace-nowrap">' +
              fromPriceInCurrencyWrap(
                priceInCurrency(
                  price.calculated_base_prices.original_price_min,
                ),
              ) +
              "</span>";
            returnData.line_1_price = price.calculated_base_prices.original_price_min;
            returnData.line_2 =
              '<span class="font-bold inActionPrice">' +
              priceInCurrency(price.calculated_base_prices.price_min) +
              "</span>";
            returnData.line_2_price = price.calculated_base_prices.price_min;
            returnData.rule = "1.a.i.2.a.ii.1.a.";
            returnData.active_line = 2;
          } else {
            // 1.a.i.2.a.ii.1.b. Nem (tehát több eredeti akciós ár van) - 12. kártya
            returnData.line_1 =
              '<span class="originalPrice whitespace-nowrap">' +
              fromPriceInCurrencyWrap(
                priceInCurrency(
                  price.calculated_base_prices.original_price_min,
                ),
              ) +
              "</span>";
            returnData.line_1_price = price.calculated_base_prices.original_price_min;
            returnData.line_2 =
              '<span class="font-bold inActionPrice">' +
              fromPriceInCurrencyWrap(
                priceInCurrency(price.calculated_base_prices.price_min),
              ) +
              "</span>";
            returnData.line_2_price = price.calculated_base_prices.price_min;
            returnData.rule = "1.a.i.2.a.ii.1.b.";
            returnData.active_line = 2;
          }
        }
      }
    } else {
      // 1.b, a felhasználó nincs bejelentkezve vagy nem TV
      // elvileg minden bejelentkezett user TV, de a logikában mi ezt ne hardcode-oljuk itt

      // 1.b.1
      // eslint-disable-next-line no-lonely-if
      if (
        price.calculated_base_prices.original_price_min ===
        price.calculated_base_prices.price_min
      ) {
        // 1.b.i.1. Igen (tehát nem akciós)

        // 1.b.i.1.a.
        if (
          price.calculated_base_prices.price_min ===
          price.calculated_base_prices.price_max
        ) {
          // 1.b.i.1.a.i. Igen (tehát minden variánsnak egy ára van) - 1. kártya
          returnData.line_1 =
            '<span class="whitespace-nowrap">' +
            priceInCurrency(price.calculated_base_prices.price_min) +
            "</span>";
          returnData.line_1_price = price.calculated_base_prices.price_min;
          returnData.line_2 =
            "<span>" +
            priceInCurrencyWrap(
              priceInCurrency(price.calculated_pricelist_1_prices.price_min),
            ) +
            "</span>";
          returnData.line_2_price = price.calculated_pricelist_1_prices.price_min;
          returnData.line_2_highlight = true;
          returnData.rule = "1.b.i.1.a.i.";
          returnData.active_line = 1;
        } else {
          // 1.b.i.1.a.ii. Nem (tehát több ár van) - 2. kártya
          returnData.line_1 =
            '<span class="whitespace-nowrap">' +
            fromPriceInCurrencyWrap(
              priceInCurrency(price.calculated_base_prices.price_min),
            ) +
            "</span>";
          returnData.line_1_price = price.calculated_base_prices.price_min;
          returnData.line_2 =
            "<span>" +
            fromPriceInCurrencyWrap(
              priceInCurrency(price.calculated_pricelist_1_prices.price_min),
              true,
            ) +
            "</span>";
          returnData.line_2_price = price.calculated_pricelist_1_prices.price_min;
          returnData.line_2_highlight = true;
          returnData.rule = "1.b.i.1.a.ii.";
          returnData.active_line = 1;
        }
      } else {
        // 1.b.i.2. Nem (tehát akciós)

        // 1.b.i.2.a.
        // eslint-disable-next-line no-lonely-if
        if (
          price.calculated_base_prices.original_price_min ===
          price.calculated_base_prices.original_price_max
        ) {
          // 1.b.i.2.a.i. Igen (tehát egyféle eredeti ár van)

          // 1.b.i.2.a.i.1.
          if (
            price.calculated_base_prices.price_min ===
            price.calculated_base_prices.price_max
          ) {
            // 1.b.i.2.a.i.1.a. Igen (tehát minden variánsnak egy akciós ára van) - 3. kártya
            returnData.line_1 =
              '<span class="originalPrice whitespace-nowrap">' +
              priceInCurrency(price.calculated_base_prices.original_price_min) +
              "</span>";
            returnData.line_1_price = price.calculated_base_prices.original_price_min;
            returnData.line_2 =
              '<span class="inActionPrice font-bold">' +
              priceInCurrency(price.calculated_base_prices.price_min) +
              "</span>";
            returnData.line_2_price = price.calculated_base_prices.price_min;
            returnData.rule = "1.b.i.2.a.i.1.a.";
            returnData.active_line = 2;
          } else {
            // 1.b.i.2.a.i.1.b. Nem (tehát több akciós ár van) - 4. kártya
            returnData.line_1 =
              '<span class="originalPrice whitespace-nowrap">' +
              priceInCurrency(price.calculated_base_prices.original_price_min) +
              "</span>";
            returnData.line_1_price = price.calculated_base_prices.original_price_min;
            returnData.line_2 =
              '<span class="inActionPrice font-bold">' +
              fromPriceInCurrencyWrap(
                priceInCurrency(price.calculated_base_prices.price_min),
              ) +
              "</span>";
            returnData.line_2_price = price.calculated_base_prices.price_min;
            returnData.rule = "1.b.i.2.a.i.1.b.";
            returnData.active_line = 2;
          }
        } else {
          // 1.b.i.2.a.ii. Nem (tehát több eredeti ár van)

          // 1.b.i.2.a.ii.1
          // eslint-disable-next-line no-lonely-if
          if (
            price.calculated_base_prices.original_price_min ===
            price.calculated_base_prices.price_max
          ) {
            // 1.b.i.2.a.ii.1.a. Igen (tehát minden variánsnak egy akciós ára van) - 5. kártya
            returnData.line_1 =
              '<span class="originalPrice whitespace-nowrap">' +
              fromPriceInCurrencyWrap(
                priceInCurrency(
                  price.calculated_base_prices.original_price_min,
                ),
              ) +
              "</span>";
            returnData.line_1_price = price.calculated_base_prices.original_price_min;
            returnData.line_2 =
              '<span class="inActionPrice font-bold">' +
              fromPriceInCurrencyWrap(priceInCurrency(price.calculated_base_prices.price_min)) +
              "</span>";
            returnData.line_2_price = price.calculated_base_prices.price_min;
            returnData.rule = "1.b.i.2.a.ii.1.a.";
            returnData.active_line = 2;
          } else {
            // 1.b.i.2.a.ii.1.b. Nem (tehát több akciós ár van) - 6. kártya
            returnData.line_1 =
              '<span class="originalPrice whitespace-nowrap">' +
              fromPriceInCurrencyWrap(
                priceInCurrency(
                  price.calculated_base_prices.original_price_min,
                ),
              ) +
              "</span>";
            returnData.line_1_price = price.calculated_base_prices.original_price_min;
            returnData.line_2 =
              '<span class="inActionPrice font-bold">' +
              fromPriceInCurrencyWrap(
                priceInCurrency(price.calculated_base_prices.price_min),
              ) +
              "</span>";
            returnData.line_2_price = price.calculated_base_prices.price_min;
            returnData.rule = "1.b.i.2.a.ii.1.b.";
            returnData.active_line = 2;
          }
        }
      }
    }
  } else if (method === "product") {
    // return JSON.stringify(price);
    // full product meilisearch object, we need to take accoint the usergroup
    // console.log(price);

    // MNTX-405
    if (!useBasePrices) {
      // 1.a

      // 1.a.i
      if (price.original_price === price.price) {
        // 1.a.i.1 (a variáns nem akciós)
        returnData.line_1 =
          '<div class="originalPrice whitespace-nowrap">' +
          priceInCurrency(price.original_price) +
          "</div>";
        returnData.line_1_price = price.original_price;
        returnData.line_2 =
          '<span">' +
          priceInCurrencyWrap(priceInCurrency(price.prices[0]?.price)) +
          "</span>";
        returnData.line_2_price = price.prices[0]?.price;
        returnData.rule = "1.a.i.1";
        returnData.line_2_highlight = true;
        returnData.active_line = 2;
      } else {
        // 1.a.i.2  (a variáns akciós)

        // 1.a.i.2.a
        // eslint-disable-next-line no-lonely-if
        if (price.price === price.prices[0]?.price) {
          // 1.a.i.2.a.i. Igen (az akció mértéke kedvezőbb, mint a TV ár)
          returnData.line_1 =
            '<div class="originalPrice whitespace-nowrap">' +
            priceInCurrency(price.original_price) +
            "</div>";
          returnData.line_1_price = price.original_price;
          returnData.line_2 =
            '<span class="inActionPrice font-bold">' +
            priceInCurrency(price.price) +
            "</span>";
          returnData.line_2_price = price.price;
          returnData.rule = "1.a.i.2.a.i";
          returnData.active_line = 2;
        } else {
          // 1.a.i.2.a.ii. Nem (az akció mértéke kisebb, mint a TV ár):
          returnData.line_1 =
            '<div class="originalPrice whitespace-nowrap">' +
            priceInCurrency(price.original_price) +
            "</div>";
          returnData.line_1_price = price.original_price;
          returnData.line_2 =
            "<span>" +
            priceInCurrencyWrap(priceInCurrency(price.prices[0]?.price)) +
            "</span>";
          returnData.line_2_price = price.prices[0]?.price;
          returnData.rule = "1.a.i.2.a.ii";
          returnData.line_2_highlight = true;
          returnData.active_line = 2;
        }
      }
    } else {
      // 1.b Nem (nem bejelentkezett user – vendég)

      // 1.b.i
      // eslint-disable-next-line no-lonely-if
      if (price.price === price.original_price) {
        // 1.b.i.1. Igen (a variáns nem akciós)
        returnData.line_1 =
          '<div class="whitespace-nowrap">' +
          priceInCurrency(price.price) +
          "</div>";
        returnData.line_1_price = price.price;
        returnData.line_2 =
          "<span>" +
          priceInCurrencyWrap(priceInCurrency(price.prices[0]?.price)) +
          "</span>";
        returnData.line_2_price = price.prices[0]?.price;
        returnData.rule = "1.b.i.1.";
        returnData.line_2_highlight = true;
        returnData.active_line = 1;
      } else {
        // 1.b.i.2. Nem (a variáns akciós)
        returnData.line_1 =
          '<div class="originalPrice whitespace-nowrap">' +
          priceInCurrency(price.original_price) +
          "</div>";
        returnData.line_1_price = price.original_price;
        returnData.line_2 =
          '<span class="inActionPrice font-bold">' +
          priceInCurrency(price.price) +
          "</span>";
        returnData.line_2_price = price.price;
        returnData.rule = "1.b.i.2.";
        returnData.active_line = 2;
      }
    }
  }

  return returnData;
}

export function usePriceFormatter(price: any, method = "") {
  /*
  console.log(typeof price);
  console.log(method);
  console.log(price);
  */
  if (typeof price === "string") {
    price = parseFloat(price);
    if (price) {
      return priceInCurrency(price);
    }
  } else if (typeof price === "number") {
    return priceInCurrency(price);
  } else if (method === "masterProduct") {
    // full product meilisearch object, we need to take accoint the usergroup
    const { status, data } = useAuth();
    // console.log(price);

    if (status.value === "authenticated") {
      if (
        Array.isArray(data?.value?.usergroups) &&
        data?.value?.usergroups?.includes(1)
      ) {
        // 1.a: a felhasználó TV

        // 1.a.i: akciós a termék?
        if (
          price.calculated_base_prices.original_price_min ===
          price.calculated_base_prices.price_min
        ) {
          // 1.a.i.1: nem akciós

          // 1.a.i.1.a: minden variáns ára egyforma?
          if (
            price.calculated_base_prices.original_price_min ===
            price.calculated_base_prices.original_price_max
          ) {
            // 1.a.i.1.a.i: igen, minden variáns ára egyforma
            return (
              '<!-- 1.a.i.1.a.i --><div class="originalPrice whitespace-nowrap">' +
              priceInCurrency(price.calculated_base_prices.original_price_min) +
              '</div><div class="text-xs">' +
              useNuxtApp().$i18n.t("pricelist_1_price") +
              '</div><div class="font-bold">' +
              priceInCurrency(price.calculated_pricelist_1_prices.price_min) +
              "</div>"
            );
          } else {
            // 1.a.i.1.a.ii: nem, a variánsok ára különbözik
            return (
              '<!-- 1.a.i.1.a.ii --><div class="originalPrice whitespace-nowrap">' +
              priceInCurrency(price.calculated_base_prices.original_price_min) +
              " - " +
              priceInCurrency(price.calculated_base_prices.original_price_max) +
              '</div><div class="text-xs">' +
              useNuxtApp().$i18n.t("pricelist_1_price") +
              '</div><div class="font-bold">' +
              priceInCurrency(price.calculated_pricelist_1_prices.price_min) +
              " - " +
              priceInCurrency(price.calculated_pricelist_1_prices.price_max) +
              "</div>"
            );
          }
        } else {
          // 1.a.i.2: a termék akciós

          // 1.a.i.2.a
          // eslint-disable-next-line no-lonely-if
          if (
            price.calculated_base_prices.original_price_min ===
            price.calculated_base_prices.original_price_max
          ) {
            // 1.a.i.2.a.i (Egyféle lista áruk van)

            // 1.a.i.2.a.i.1
            if (
              price.calculated_base_prices.price_min ===
              price.calculated_pricelist_1_prices.price_min
            ) {
              // 1.a.i.2.a.i.1.a (igen)

              // 1.a.i.2.a.i.1.a.i
              if (
                price.calculated_base_prices.price_min ===
                price.calculated_base_prices.price_max
              ) {
                // 1.a.i.2.a.i.1.a.i.1 (tehát minden variánsnak egy ára van)
                return (
                  '<!-- 1.a.i.2.a.i.1.a.i.1 --><div class="originalPrice whitespace-nowrap">' +
                  priceInCurrency(
                    price.calculated_base_prices.original_price_min,
                  ) +
                  '</div><div class="inActionPrice font-bold">' +
                  priceInCurrency(price.calculated_base_prices.price_min) +
                  "</div>"
                );
              } else {
                // 1.a.i.2.a.i.1.a.i.2 (tehát vannak különböző árú variánsok)

                // 1.a.i.2.a.i.1.a.i.2.a
                // eslint-disable-next-line no-lonely-if
                if (
                  price.calculated_base_prices.price_max ===
                  price.calculated_base_prices.original_price_max
                ) {
                  // 1.a.i.2.a.i.1.a.i.2.a.i (van teljes árú variáns)
                  return (
                    '<!-- 1.a.i.2.a.i.1.a.i.2.a.i.1 --><div class="originalPrice whitespace-nowrap">' +
                    priceInCurrency(
                      price.calculated_base_prices.original_price_min,
                    ) +
                    '</div><div class="inActionPrice font-bold">' +
                    priceInCurrency(price.calculated_base_prices.price_min) +
                    " - " +
                    priceInCurrency(
                      price.calculated_pricelist_1_prices.price_max,
                    ) +
                    "</div>"
                  );
                } else {
                  // 1.a.i.2.a.i.1.a.i.2.a.ii (minden variáns akciós)
                  return (
                    '<!-- 1.a.i.2.a.i.1.a.i.2.a.ii.1 --><div class="originalPrice whitespace-nowrap">' +
                    priceInCurrency(
                      price.calculated_base_prices.original_price_min,
                    ) +
                    '</div><div class="inActionPrice font-bold">' +
                    priceInCurrency(price.calculated_base_prices.price_min) +
                    " - " +
                    priceInCurrency(price.calculated_base_prices.price_max) +
                    "</div>"
                  );
                }
              }
            } else {
              // 1.a.i.2.a.i.1.b (5% akció van a termékre)

              // 1.a.i.2.a.i.1.b.i
              // eslint-disable-next-line no-lonely-if
              if (
                price.calculated_base_prices.price_min ===
                price.calculated_base_prices.price_max
              ) {
                // 1.a.i.2.a.i.1.b.i.1
                return (
                  '<!-- 1.a.i.2.a.i.1.b.i.1 --><div class="originalPrice whitespace-nowrap">' +
                  priceInCurrency(
                    price.calculated_base_prices.original_price_min,
                  ) +
                  '</div><div class="text-xs">' +
                  useNuxtApp().$i18n.t("pricelist_1_price") +
                  '</div><div class="font-bold">' +
                  priceInCurrency(
                    price.calculated_pricelist_1_prices.price_min,
                  ) +
                  "</div>"
                );
              } else {
                // 1.a.i.2.a.i.1.b.i.2
                return (
                  '<!-- 1.a.i.2.a.i.1.b.i.2 --><div class="originalPrice whitespace-nowrap">' +
                  priceInCurrency(
                    price.calculated_base_prices.original_price_min,
                  ) +
                  " - " +
                  priceInCurrency(
                    price.calculated_base_prices.original_price_max,
                  ) +
                  '</div><div class="text-xs">' +
                  useNuxtApp().$i18n.t("pricelist_1_price") +
                  '</div><div class="font-bold">' +
                  priceInCurrency(
                    price.calculated_pricelist_1_prices.price_min,
                  ) +
                  " - " +
                  priceInCurrency(
                    price.calculated_pricelist_1_prices.price_max,
                  ) +
                  "</div>"
                );
              }
            }
          } else {
            // 1.a.i.2.a.ii (Különböző lista árak)

            // 1.a.i.2.a.ii.1
            // eslint-disable-next-line no-lonely-if
            if (
              price.calculated_base_prices.price_min ===
              price.calculated_pricelist_1_prices.price_min
            ) {
              // 1.a.i.2.a.ii.1.a

              // 1.a.i.2.a.ii.1.a.i
              if (
                price.calculated_base_prices.price_min ===
                price.calculated_base_prices.price_max
              ) {
                // 1.a.i.2.a.ii.1.a.i.1 (tehát minden variánsnak egy ára van)
                return (
                  '<!-- 1.a.i.2.a.ii.1.a.i.1 --><div class="originalPrice whitespace-nowrap">' +
                  priceInCurrency(
                    price.calculated_base_prices.original_price_min,
                  ) +
                  " - " +
                  priceInCurrency(
                    price.calculated_base_prices.original_price_max,
                  ) +
                  '</div><div class="font-bold">' +
                  priceInCurrency(price.calculated_base_prices.price_min) +
                  "</div>"
                );
              } else {
                // 1.a.i.2.a.ii.1.a.i.2 (tehát vannak különböző árú variánsok)

                // 1.a.i.2.a.ii.1.a.i.2.a
                // eslint-disable-next-line no-lonely-if
                if (
                  price.calculated_base_prices.price_max ===
                  price.calculated_base_prices.original_price_max
                ) {
                  // 1.a.i.2.a.ii.1.a.i.2.a.i (Igaz, van teljes árú variáns)
                  return (
                    '<!-- 1.a.i.2.a.ii.1.a.i.2.a.i.1 --><div class="originalPrice whitespace-nowrap">' +
                    priceInCurrency(
                      price.calculated_base_prices.original_price_min,
                    ) +
                    " - " +
                    priceInCurrency(
                      price.calculated_base_prices.original_price_max,
                    ) +
                    '</div><div class="inActionPrice font-bold">' +
                    priceInCurrency(price.calculated_base_prices.price_min) +
                    " - " +
                    priceInCurrency(
                      price.calculated_pricelist_1_prices.price_max,
                    ) +
                    "</div>"
                  );
                } else {
                  // 1.a.i.2.a.ii.1.a.i.2.a.ii (Hamis, minden variáns akciós)
                  return (
                    '<!-- 1.a.i.2.a.ii.1.a.i.2.a.ii.1 --><div class="originalPrice whitespace-nowrap">' +
                    priceInCurrency(
                      price.calculated_base_prices.original_price_min,
                    ) +
                    " - " +
                    priceInCurrency(
                      price.calculated_base_prices.original_price_max,
                    ) +
                    '</div><div class="font-bold">' +
                    priceInCurrency(price.calculated_base_prices.price_min) +
                    " - " +
                    priceInCurrency(price.calculated_base_prices.price_max) +
                    "</div>"
                  );
                }
              }
            } else {
              // 1.a.i.2.a.ii.1.b (5% akció van a termékre)
              return (
                '<!-- 1.a.i.2.a.ii.1.b.1 --><div class="originalPrice whitespace-nowrap">' +
                priceInCurrency(
                  price.calculated_base_prices.original_price_min,
                ) +
                " - " +
                priceInCurrency(
                  price.calculated_base_prices.original_price_max,
                ) +
                '</div><div class="text-xs">' +
                useNuxtApp().$i18n.t("pricelist_1_price") +
                '</div><div class="font-bold">' +
                priceInCurrency(price.calculated_pricelist_1_prices.price_min) +
                " - " +
                priceInCurrency(price.calculated_pricelist_1_prices.price_max) +
                "</div>"
              );
            }
          }
        }
      }
    }

    // 1.b, a felhasználó vendég, vagy nem TV

    // 1.b.i
    if (
      price.calculated_base_prices.original_price_min ===
      price.calculated_base_prices.price_min
    ) {
      // 1.b.i.1, a termék nem akciós

      // 1.b.i.1.a
      if (
        price.calculated_base_prices.original_price_min ===
        price.calculated_base_prices.original_price_max
      ) {
        // 1.b.i.1.a.i, tehát minden variánsnak egy ára van
        return (
          '<!-- 1.b.i.1.a.i --><div class="font-bold">' +
          priceInCurrency(price.calculated_base_prices.original_price_min) +
          "</div>"
        );
      } else {
        // 1.b.i.1.a.ii, tehát vannak különböző árú variánsok
        return (
          '<!-- 1.b.i.1.a.ii --><div class="font-bold">' +
          priceInCurrency(price.calculated_base_prices.original_price_min) +
          " - " +
          priceInCurrency(price.calculated_base_prices.original_price_max) +
          "</div>"
        );
      }
    } else {
      // 1.b.i.2

      // 1.b.i.2.a
      // eslint-disable-next-line no-lonely-if
      if (
        price.calculated_base_prices.original_price_min ===
        price.calculated_base_prices.original_price_max
      ) {
        // 1.b.i.2.a.ii

        // 1.b.i.2.a.ii.1
        if (
          price.calculated_base_prices.price_min ===
          price.calculated_base_prices.price_max
        ) {
          // 1.b.i.2.a.ii.1.a, tehát minden variánsnak egy ára van
          return (
            '<!-- 1.b.i.2.a.ii.1.a --><div class="originalPrice whitespace-nowrap">' +
            priceInCurrency(price.calculated_base_prices.original_price_min) +
            '</div><div class="inActionPrice font-bold">' +
            priceInCurrency(price.calculated_base_prices.price_min) +
            "</div>"
          );
        } else {
          // 1.b.i.2.a.ii.1.b, tehát vannak különböző árú variánsok
          return (
            '<!-- 1.b.i.2.a.ii.1.b --><div class="originalPrice whitespace-nowrap">' +
            priceInCurrency(price.calculated_base_prices.original_price_min) +
            '</div><div class="inActionPrice font-bold">' +
            priceInCurrency(price.calculated_base_prices.price_min) +
            " - " +
            priceInCurrency(price.calculated_base_prices.price_max) +
            "</div>"
          );
        }
      } else {
        // 1.b.i.2.a.i

        // 1.b.i.2.a.i.1
        // eslint-disable-next-line no-lonely-if
        if (
          price.calculated_base_prices.price_min ===
          price.calculated_base_prices.price_max
        ) {
          // 1.b.i.2.a.i.1.a, tehát minden variánsnak egy ára van
          return (
            '<!-- 1.b.i.2.a.i.1.a --><div class="originalPrice whitespace-nowrap">' +
            priceInCurrency(price.calculated_base_prices.original_price_min) +
            " - " +
            priceInCurrency(price.calculated_base_prices.original_price_max) +
            '</div><div class="inActionPrice font-bold">' +
            priceInCurrency(price.calculated_base_prices.price_min) +
            "</div>"
          );
        } else {
          // 1.b.i.2.a.i.1.b, tehát vannak különböző árú variánsok
          return (
            '<!-- 1.b.i.2.a.i.1.b --><div class="originalPrice whitespace-nowrap">' +
            priceInCurrency(price.calculated_base_prices.original_price_min) +
            " - " +
            priceInCurrency(price.calculated_base_prices.original_price_max) +
            '</div><div class="inActionPrice font-bold">' +
            priceInCurrency(price.calculated_base_prices.price_min) +
            " -" +
            priceInCurrency(price.calculated_base_prices.price_max) +
            "</div>"
          );
        }
      }
    }
  } else if (method === "product") {
    // return JSON.stringify(price);
    const { status, data } = useAuth();
    // console.log(price);

    if (status.value === "authenticated") {
      if (
        Array.isArray(data?.value?.usergroups) &&
        data?.value?.usergroups?.includes(1)
      ) {
        if (price.price === price.original_price) {
          return (
            '<div class="originalPrice whitespace-nowrap">' +
            priceInCurrency(price.original_price) +
            '</div><div class="text-xs">' +
            useNuxtApp().$i18n.t("pricelist_1_price") +
            '</div><div class="font-bold">' +
            priceInCurrency(price.pricelist_price) +
            "</div>"
          );
        } else {
          // eslint-disable-next-line no-lonely-if
          if (price.price === price.pricelist_price) {
            return (
              '<div class="originalPrice whitespace-nowrap">' +
              priceInCurrency(price.original_price) +
              '</div><div class="inActionPrice font-bold">' +
              priceInCurrency(price.price) +
              "</div>"
            );
          } else {
            return (
              '<div class="originalPrice whitespace-nowrap">' +
              priceInCurrency(price.original_price) +
              '</div><div class="text-xs">' +
              useNuxtApp().$i18n.t("pricelist_1_price") +
              '</div><div class="font-bold">' +
              priceInCurrency(price.pricelist_price) +
              "</div>"
            );
          }
        }
      }
    }

    // Vendég, vagy belépett de nem TV
    if (price.original_price === price.price) {
      return (
        '<div class="font-bold">' + priceInCurrency(price.price) + "</div>"
      );
    } else {
      return (
        '<div class="originalPrice whitespace-nowrap">' +
        priceInCurrency(price.original_price) +
        '</div><div class="inActionPrice font-bold">' +
        priceInCurrency(price.price) +
        "</div>"
      );
    }
  }
}

export function usePriceInCurrency(price: any) {
  return priceInCurrency(price);
}
